import type { ContainerRegistry } from '../types/ContainerRegistry.js';
import type { RenderArgs } from '../render/render.js';
import { render } from '../render/render.js';

import { loadScript } from './loadScript.js';

export interface LoadModuleArgs extends RenderArgs {
  url: string;
}

export const loadModule = async (args: LoadModuleArgs) => {
  const {
    url,
    name: { scope },
  } = args;

  const override = localStorage.getItem(scope);
  const remoteEntryUrl = override ?? url;

  const existingContainer = (window as unknown as ContainerRegistry)[scope];

  if (existingContainer) {
    return render(args);
  }

  return loadScript(remoteEntryUrl, async () => {
    return render(args);
  });
};

// eslint-disable-next-line import/no-default-export
export default loadModule;
